import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackKey } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import type { DisplayLocation } from './types'

export const trackBetSlipButtonClick = () => trackKey(keys.appHeaderBetSlipButtonClick)
export const trackPendingBetsButtonClick = (location: DisplayLocation) =>
  trackKey(location === 'betslip' ? keys.betSlipPendingBetsClick : keys.appHeaderPendingBetsClick)
